import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ESolarPlantViewType } from "../../../shared/oversight-core/enums/solar-plant-view-type";
import { RootState } from "../../store";

export type SiteChartFilter = {
  startDate: string;
  endDate: string;
  viewType?: ESolarPlantViewType;
  isFilterCustom: boolean;
};

const initialState: SiteChartFilter = {
  startDate: new Date().toISOString(),
  endDate: new Date().toISOString(),
  viewType: undefined,
  isFilterCustom: false,
};

export const siteChartFilterSlice = createSlice({
  name: "siteChartFilter",
  initialState: { ...initialState },
  reducers: {
    setSiteChartFilter: (state, action: PayloadAction<SiteChartFilter>) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
      state.viewType = action.payload.viewType;
      state.isFilterCustom = action.payload.isFilterCustom;
    },
    resetSiteChartFilter: (state) => {
      state.startDate = initialState.startDate;
      state.endDate = initialState.endDate;
      state.viewType = undefined;
      state.isFilterCustom = false;
    },
  },
});

export const { setSiteChartFilter, resetSiteChartFilter } =
  siteChartFilterSlice.actions;

export const selectSiteChartFilter = (state: RootState) =>
  state.siteChartFilter;

export default siteChartFilterSlice.reducer;
